<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-blank-piece-of-paper">
<h1>A Blank Piece of Paper</h1>
<p style="text-indent:0em">Everyone starts out as a child</p>
<p style="text-indent:0em">with a blank piece of paper,</p>
<p style="text-indent:0em">a box of crayons,</p>
<p style="text-indent:0em">an imagination,</p>
<p style="text-indent:0em">and no doubts.</p><br/>
<p style="text-indent:0em">And then adults tell them</p>
<p style="text-indent:0em">to color inside the lines,</p>
<p style="text-indent:0em">what color a flower should be,</p>
<p style="text-indent:0em">how tall a tree grows, and</p>
<p style="text-indent:0em">use a new piece of paper.</p><br/>
<p style="text-indent:0em">I always wondered what was wrong</p>
<p style="text-indent:0em">with my sorta square brown flowers,</p>
<p style="text-indent:0em">and trees too tall for airplanes.</p>
<p style="text-indent:0em">And why no one ever told me</p>
<p style="text-indent:0em">those are great just the way they are.</p><br/>
<p style="text-indent:0em">Maybe that’s why, in my later years</p>
<p style="text-indent:0em">I picked up my paper and crayons again,</p>
<p style="text-indent:0em">and began to write with words,</p>
<p style="text-indent:0em">the pictures I always wanted to paint</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?4040919a